import type { FC } from "react";
import { GapsSheetKind, useGapsSheet } from "../useGapsSheet";
import { GapsApproveSheet } from "./GapsApproveSheet";
import { GapsPostedSheet } from "./GapsPostedSheet";

type Props = {
	/**
	 * The host's own page, for a host other than the home: "Add someone directly" opens the add sheet over the home, and
	 * backing out of it returns here. `null` on the home, which the add sheet already sits on.
	 */
	addDirectlyBackPath: string | null;
};

/**
 * The two sheets about a POSTED request — its actions (P3-10) and the approve confirm (P3-6) — hosted by both screens
 * that list requests: the home (its Posted tab) and Open Shifts. They are different routes, so only one host is ever
 * mounted, and each opens off the same intent store as every other gaps sheet.
 *
 * Neither needs the home's day model: a posted request carries its own day. What they hand on to — the assign-unit sheet
 * after an approval, the add sheet for "Add someone directly" — is the home's, opened on the request's day
 * (`useOpenOnGapsDay`), which is also why Open Shifts only closes these two kinds when it unmounts.
 */
export const GapsRequestSheets: FC<Props> = ({ addDirectlyBackPath }) => {
	const { intent } = useGapsSheet();
	return (
		<>
			{/* The store's own intent objects, not copies: a new object is a new opening (see `useSheetOpening`), and each
			    sheet closes only its own. */}
			<GapsPostedSheet target={intent?.kind === GapsSheetKind.PostedActions ? intent : null} addDirectlyBackPath={addDirectlyBackPath} />
			<GapsApproveSheet target={intent?.kind === GapsSheetKind.ApproveConfirm ? intent : null} />
		</>
	);
};
